import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ServicesPage from "./pages/ServicesPage";
import ContactPage from "./pages/ContactPage";
import BlogArchive from "./pages/BlogArchive";
import BlogPostTemplate from "./components/BlogPostTemplate";
import DemoPreview from "./pages/DemoPreview";
import FAQsPage from "./pages/FAQsPage";
import LandingPage from "./components/LandingPage";
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import AuthorSpotlight from './pages/AuthorSpotlight';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/blog" element={<BlogArchive />} />
        <Route path="/blog/:slug" element={<BlogPostTemplate />} />
        <Route path="/demo-preview" element={<DemoPreview />} />
        <Route path="/faqs" element={<FAQsPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/author-spotlight" element={<AuthorSpotlight />} />
      </Routes>
    </Router>
  );
};

export default App;
